enum ContractSortTypeEnum {
  BY_ID = "BY_ID", // Default sorting when sortOption is null (Client side only)
  BY_DATE = "BY_DATE",
  BY_SELLER_NAME = "BY_SELLER_NAME",
  BY_BUYER_NAME = "BY_BUYER_NAME",
  BY_AMOUNT_REMAINING = "BY_AMOUNT_REMAINING",
}

export default ContractSortTypeEnum;
